import { Controller } from "@hotwired/stimulus";
import { topSpiderChartInit } from '../recommended_news/top_spider_chart'; 

export default class extends Controller {
  static values = {
    sc_server: String,
  }

  connect() {
    topSpiderChartInit()
  }
}
